import { makeAutoObservable } from 'mobx'
import { PropertyValue } from 'api/clients/PropertyClient'
import { AncestorProject, HandbookItem, MinimalFile } from 'types'
import { SubmitProps } from 'components/NavRightClickMenu/components/ActionModal/ActionModal'

/**
 * Store to manage the TemplatePicker in the editor and template modals.
 */
class ConfirmationModalStore {
  /**
   * The title of the parent.
   */
  currentParentTitle: string | undefined = undefined

  /**
   * The key of the destination folder.
   */
  destinationKey: string = ''

  /**
   * The destination folder.
   */
  selectedFolder: AncestorProject | null = null

  /**
   * The files to move.
   */
  selectedFiles: MinimalFile[] | HandbookItem[] = []

  /**
   * The default workflow property of destination.
   */
  workflowDefaultProperty: Pick<PropertyValue, 'value' | 'meta'> | undefined

  /**
   * Flag to show the confirmation modal.
   */
  isConfirmationModalOpen: boolean = false

  /**
   * Flag to determine moving to different workspace.
   */
  differentWorkspace: boolean = false

  /**
   * Name of destination workspace (if moving to different workspace).
   */
  workspaceName: string | null = null

  /**
   * Flag to track if we are moving to root folder
   */
  movingToRoot: boolean = false

  /**
   * Workspace to save file into
   */
  newWorkspaceId?: number

  /**
   * The id of the current parent
   */
  parentId?: string = ''

  /**
   * Destination Title
   */
  destinationTitle: string | null = null

  /**
   * Is the destination a child of current parent?
   */
  destinationIsAChild: boolean = false

  /**
   * Submit method
   */
  submit: ({ selectedFolder, newWorkspaceId }: SubmitProps) => void = () => {}

  constructor() {
    makeAutoObservable(this)
  }

  setState(state: Partial<ConfirmationModalStore>) {
    Object.assign(this, state)
  }

  openModal() {
    this.setState({
      isConfirmationModalOpen: true,
    })
  }

  closeModal() {
    this.setState({
      isConfirmationModalOpen: false,
    })
  }
}

const confirmationModalStore = new ConfirmationModalStore()

export default confirmationModalStore
